import { Experiment } from '@ms/yammer-data/dist/state/types';
import { NetworkQuestionsEnablementMode } from '@ms/yammer-graphql';
import { useExperimentTreatmentWithoutReporting } from '@ms/yammer-hooks/dist/experiments';
import { useFeatureAccessSettings } from '@ms/yammer-hooks/dist/featureAccessSettings';

import { UseUIFeatureCheck } from '../types';

export const useAreQuestionsEnabled: UseUIFeatureCheck = () => {
  const isAnswersInVivaGAEnabled = useExperimentTreatmentWithoutReporting(Experiment.AnswersInVivaGA) === true;

  const { viewerCanAccessNetworkQuestions, networkQuestionsEnablementMode } = useFeatureAccessSettings() ?? {};

  return (
    isAnswersInVivaGAEnabled === true &&
    viewerCanAccessNetworkQuestions === true &&
    networkQuestionsEnablementMode !== NetworkQuestionsEnablementMode.DISABLED
  );
};

export const useIsQuestionsOnlyMode: UseUIFeatureCheck = () => {
  const answersOnlyModeExperiment = useExperimentTreatmentWithoutReporting(Experiment.AnswersOnlyMode);
  const { networkQuestionsEnablementMode } = useFeatureAccessSettings() ?? {};

  return (
    answersOnlyModeExperiment === true &&
    networkQuestionsEnablementMode === NetworkQuestionsEnablementMode.ENABLED_NETWORK_QUESTIONS_ONLY_MODE
  );
};
